<template>
  <div>
    <v-container grid-list-md class="white text-left">
      <v-row>
        <v-col cols="12" class="body-2 grey--text text-left pb-0">
          <div>
            <v-breadcrumbs :items="routeItems" divider=">"></v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="headline pb-0"
          >No. Pedido: {{ dataOrder.saleOrderID }}</v-col
        >
        <v-col cols="12" class="headline pb-0"
          >No. Orden: {{ dataOrder.id }}</v-col
        >
        <v-col cols="12" class="pt-0 grey--text title">{{
          dataOrder.location
        }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="headline body-1 pb-0">
          <span class="grey--text font-weight-regular">Contacto:</span>
          {{ dataOrder.userContact }}
        </v-col>
        <v-col cols="12" class="headline body-1 pt-0">
          <span class="grey--text">Tel:</span>
          {{ dataOrder.userPhone }}
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!exist">
      <v-row no-gutters>
        <v-col cols="12" class="text-center"
          >El pedido que buscaste no pudo ser encontrado.</v-col
        >
      </v-row>
    </v-container>
    <v-container
      v-show="exist"
      class="pt-0"
      v-for="(data, index) in dataEquipment"
      :key="data.key"
    >
      <v-col cols="12" class="pb-0">
        <v-card class="pa-2">
          {{ data.correctStatus }}
          <p class="title ml-1 mt-2 mb-0 font-weight-regular">
            No. Serie: {{ data.machineSerie }}
          </p>
          <p class="subheading ml-1 mt-1 mb-0 font-weight-light">
            Modelo del equipo: {{ data.machineModel }}
          </p>
          <p class="subheading ml-1 mt-0 mb-0 font-weight-light text-uppercase">
            {{ data.machineDescription }}
          </p>
        </v-card>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header class="pa-2">
              <span class="red--text font-weight-light">
                Realizar Checklist - {{ onlyStatus(index).name }}({{
                  onlyStatus(index).onlyLetter
                }})
              </span>
              <template v-slot:actions>
                <v-icon>add</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="background-gray">
              <v-container class="pa-0">
                <v-row>
                  <v-col cols="12" class="caption pb-0"
                    >Proceso de entrega</v-col
                  >
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'deliveryOutput',
                          'delivery',
                          'output'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'delivery',
                          'output',
                          data.machineSerie,
                          { event: 'Entrega', inputOuput: 'Salida' },
                          'deliveryOutput',
                          index,
                          data.statusMap.delivery.output ? 'consult' : 'save',
                          data.status === 'deliveryOutput'
                        )
                      "
                    >
                      <span class="text-uppercase">Salida</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'deliveryOutput' &&
                            !data.statusMap.delivery.output
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.delivery.output"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'deliveryInput',
                          'delivery',
                          'input'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'delivery',
                          'input',
                          data.machineSerie,
                          { event: 'Entrega', inputOuput: 'Entrada' },
                          'deliveryInput',
                          index,
                          data.statusMap.delivery.input ? 'consult' : 'save',
                          data.status === 'deliveryInput'
                        )
                      "
                    >
                      <span class="text-uppercase">Entrada</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'deliveryInput' &&
                            !data.statusMap.delivery.input
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.delivery.input"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="caption pb-0"
                    >En periodo de renta / Mantenimiento</v-col
                  >
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'maintenanceOutput',
                          'maintenance',
                          'output'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'maintenance',
                          'output',
                          data.machineSerie,
                          { event: 'Mantenimiento', inputOuput: 'Salida' },
                          'maintenanceOutput',
                          index,
                          data.statusMap.maintenance.output
                            ? 'consult'
                            : 'save',
                          data.status === 'maintenanceOutput'
                        )
                      "
                    >
                      <span class="text-uppercase">Salida</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'maintenanceOutput' &&
                            !data.statusMap.maintenance.output
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.maintenance.output"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'maintenanceInput',
                          'maintenance',
                          'input'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'maintenance',
                          'input',
                          data.machineSerie,
                          { event: 'Mantenimiento', inputOuput: 'Entrada' },
                          'maintenanceInput',
                          index,
                          data.statusMap.maintenance.input ? 'consult' : 'save',
                          data.status === 'maintenanceInput'
                        )
                      "
                    >
                      <span class="text-uppercase">Entrada</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'maintenanceInput' &&
                            !data.statusMap.maintenance.input
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.maintenance.input"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="caption pb-0">Recolección</v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'recollectionOutput',
                          'recollection',
                          'output'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'recollection',
                          'output',
                          data.machineSerie,
                          { event: 'Recolección', inputOuput: 'Salida' },
                          'recollectionOutput',
                          index,
                          data.statusMap.recollection.output
                            ? 'consult'
                            : 'save',
                          data.status === 'recollectionOutput'
                        )
                      "
                    >
                      <span class="text-uppercase">Salida</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'recollectionOutput' &&
                            !data.statusMap.recollection.output
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.recollection.output"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'recollectionInput',
                          'recollection',
                          'input'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'recollection',
                          'input',
                          data.machineSerie,
                          { event: 'Recolección', inputOuput: 'Entrada' },
                          'recollectionInput',
                          index,
                          data.statusMap.recollection.input
                            ? 'consult'
                            : 'save',
                          data.status === 'recollectionInput'
                        )
                      "
                    >
                      <span class="text-uppercase">Entrada</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'recollectionInput' &&
                            !data.statusMap.recollection.input
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.recollection.input"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="caption pb-0">Reubicación</v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'relocationOutput',
                          'relocation',
                          'output'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'relocation',
                          'output',
                          data.machineSerie,
                          { event: 'Reubicación', inputOuput: 'Salida' },
                          'relocationOutput',
                          index,
                          data.statusMap.relocation.output ? 'consult' : 'save',
                          data.status === 'relocationOutput'
                        )
                      "
                    >
                      <span class="text-uppercase">Salida</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'relocationOutput' &&
                            !data.statusMap.relocation.output
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.relocation.output"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'relocationInput',
                          'relocation',
                          'input'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'relocation',
                          'input',
                          data.machineSerie,
                          { event: 'Reubicación', inputOuput: 'Entrada' },
                          'relocationInput',
                          index,
                          data.statusMap.relocation.input ? 'consult' : 'save',
                          data.status === 'relocationInput'
                        )
                      "
                    >
                      <span class="text-uppercase">Entrada</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'relocationInput' &&
                            !data.statusMap.relocation.input
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.relocation.input"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="caption pb-0">Rentado Servicio</v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'rented-serviceOutput',
                          'rentedService',
                          'output'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'rented-service',
                          'output',
                          data.machineSerie,
                          {
                            event: 'Rentado Servicio',
                            inputOuput: 'Salida'
                          },
                          'rented-serviceOutput',
                          index,
                          data.statusMap.rentedService.output
                            ? 'consul'
                            : 'save',
                          data.status === 'rented-serviceOutput'
                        )
                      "
                    >
                      <span class="text-uppercase">Salida</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'rented-serviceOutput' &&
                            !data.statusMap.rentedService.output
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.rentedService.output"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      v-bind="
                        getChecklistColor(
                          data,
                          'rented-serviceInput',
                          'rentedService',
                          'input'
                        )
                      "
                      class="d-flex justify-space-between"
                      @click="
                        goToChecklist(
                          data.key,
                          'rented-service',
                          'input',
                          data.machineSerie,
                          {
                            event: 'Rentado Servicio',
                            inputOuput: 'Entrada'
                          },
                          'rented-serviceInput',
                          index,
                          data.statusMap.rentedService.input
                            ? 'consult'
                            : 'save',
                          data.status === 'rented-serviceInput'
                        )
                      "
                    >
                      <span class="text-uppercase">Entrada</span>
                      <span
                        class="text-capitalize caption"
                        v-if="
                          data.status == 'rented-serviceInput' &&
                            !data.statusMap.rentedService.input
                        "
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-else-if="data.statusMap.rentedService.input"
                        >Checklist Realizado</span
                      >
                      <span class="text-capitalize caption" v-else
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  mounted() {
    this.resetDetail();
    if (this.$route.params.id) {
      this.getDetail(this.$route.params.id);
    } else if (this.$route.params.orderNumber) {
      this.getSearchedOrder({
        orderNumber: this.$route.params.orderNumber,
        orderType: this.$route.params.orderType
      });
    }
  },
  computed: {
    ...mapState("detail", ["dataOrder", "exist", "dataEquipment"]),
    routeItems() {
      let routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        element = unescape(element);
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      return routeItems;
    }
  },
  methods: {
    ...mapActions("detail", ["getDetail", "resetDetail", "getSearchedOrder"]),
    statusClass(status) {
      let color = status == "pickup" ? "orange" : "red";
      return "caption " + color + "--text";
    },
    onlyStatus(i) {
      if (this.dataEquipment[i].status) {
        switch (this.dataEquipment[i].status) {
          // :: Output status filters
          case "deliveryOutput":
            return { onlyLetter: "S", name: "Entrega" };
          case "maintenanceOutput":
            return { onlyLetter: "S", name: "Mantenimiento" };
          case "relocationOutput":
            return { onlyLetter: "S", name: "Reubicación" };
          case "recollectionOutput":
            return { onlyLetter: "S", name: "Recolección" };
          case "rented-serviceOutput":
            return { onlyLetter: "S", name: "Rentado Servicio" };
          // :: Input status filters
          case "deliveryInput":
            return { onlyLetter: "E", name: "Entrega" };
          case "maintenanceInput":
            return { onlyLetter: "E", name: "Mantenimiento" };
          case "relocationInput":
            return { onlyLetter: "E", name: "Reubicación" };
          case "recollectionInput":
            return { onlyLetter: "E", name: "Recolección" };
          case "rented-serviceInput":
            return { onlyLetter: "E", name: "Rentado Servicio" };
          default:
            return { onlyLetter: "N/A", name: "No hay checklists activos" };
        }
      }
    },
    goToChecklist(
      productID,
      event,
      checklistType,
      machineSerie,
      status,
      statusSelected,
      indexEquipment,
      action,
      validStatus
    ) {
      const statusID = this.dataEquipment[indexEquipment].status;
      this.$router.push({
        name: "checklist",
        params: {
          id: this.dataOrder.key,
          productID: productID,
          event: event,
          type: checklistType
        },
        query: {
          order: this.dataOrder.id,
          saleOrderID: this.dataOrder.saleOrderID,
          typeAction: action,
          machineSerie: machineSerie,
          event: status.event,
          inputOuput: status.inputOuput,
          statusID: statusSelected,
          correctStatus: statusID === statusSelected,
          backUrlSearch: this.$router.currentRoute.fullPath,
          invalidStatus: !validStatus
        }
      });
    },
    getChecklistColor(data, status, type, action) {
      if (data.status === status) return { color: "red", dark: true };
      if (data.status !== status && data.statusMap[type][action])
        return { color: "primary", dark: true };
      return { color: "gray", dark: false };
    }
  }
};
</script>

<style scoped>
.active-btn-checklist {
  background-color: #e21616 !important;
  color: white;
}
.background-gray {
  background-color: #efefef;
}
.line {
  border: 0.5px solid #a0a0a0;
}
.v-expansion-panel__header {
  padding: 0 0 0 5px !important;
}
.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
  .v-icon {
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
/* Border v-sheet and v-expansion-panel */
.v-sheet {
  border-radius: 0px;
}
.v-expansion-panels {
  border-radius: 0px;
}
</style>
